<!-- Кнопка копироваания записи в едином стиле проекта. -->
<template>
  <BaseTooltip
    ref="tooltip"
    :text="copied ? copiedLabel : title"
    :disabled="disabled || !text"
  >
    <base-button
      v-if="variant === 'text'"
      type="button"
      class="base-copy-button-text"
      :class="{ 'base-copy-button-text--copied': copied }"
      :disabled="disabled || !text"
      @click="copy"
    >
      <AppIcon
        class="base-copy-button-text__icon"
        :name="copied ? 'check' : 'copy'"
        :size="16"
      />
      {{ copied ? copiedLabel : label }}
    </base-button>

    <button
      v-else
      type="button"
      class="base-copy-button base-copy-button--icon"
      :class="{ 'base-copy-button--copied': copied }"
      :disabled="disabled || !text"
      @click="copy"
    >
      <AppIcon :name="copied ? 'check' : 'copy'" :size="16" />
    </button>
  </BaseTooltip>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BaseCopyButton",

  components: {
    AppIcon,
  },

  props: {
    text: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Скопировать",
    },
    copiedLabel: {
      type: String,
      default: "Скопировано",
    },
    title: {
      type: String,
      default: "Скопировать",
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "icon",
      validator: (value) => ["icon", "text"].includes(value),
    },
  },

  emits: ["copied"],

  data() {
    return {
      copied: false,
      copyTimer: null,
    };
  },

  beforeUnmount() {
    clearTimeout(this.copyTimer);
  },

  methods: {
    async copy() {
      if (this.disabled || !this.text) return;

      await this.writeToClipboard(this.text);
      this.copied = true;
      this.$emit("copied", this.text);
      clearTimeout(this.copyTimer);
      await this.$nextTick();
      this.$refs.tooltip?.showTooltip();
      this.copyTimer = setTimeout(() => {
        this.copied = false;
        this.$refs.tooltip?.hideTooltip();
      }, 2000);
    },

    async writeToClipboard(text) {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.cssText =
        "position:fixed;opacity:0;pointer-events:none;";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },
  },
};
</script>

<style scoped>
.base-copy-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  padding: 0;
  gap: 6px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #777;
  cursor: pointer;
  box-sizing: border-box;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
}

.base-copy-button:hover:not(:disabled) {
  background: #f0faf9;
  color: var(--color-green);
}

.base-copy-button:disabled {
  color: #c0c0c0;
  cursor: not-allowed;
}

.base-copy-button--copied {
  color: var(--color-green);
}

.base-copy-button--icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
}

.base-copy-button-text {
  width: 148px;
  height: 32px;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 10px;
  border-radius: 6px;
  box-sizing: border-box;
  white-space: nowrap;
}

.base-copy-button-text--copied {
  color: var(--color-green);
}

.base-copy-button-text__icon {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
}
</style>
